import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AppRoutes } from './router';
import Footer from './components/feature/Footer';
import CookieConsent from './components/feature/CookieConsent';
import { MenuProvider } from './contexts/MenuContext';

function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // No hacer scroll si la navegación incluye scrollTo (secciones del home)
    if (state && (state as any).scrollTo) return;
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, state]);

  return null;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <MenuProvider>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <main className="flex-grow bg-white">
            <AppRoutes />
          </main>
          <Footer />
          <CookieConsent />
        </div>
      </MenuProvider>
    </BrowserRouter>
  );
}

export default App;
